import React, { useState } from "react"
import { useSelector } from "react-redux"
import { redirectToOmnicuris } from "../utilities"
import { DefaultProfileIcon } from "../utilities/resources"
import Img from "./Img"
import ExpertsBottomSheet from "./ExpertsBottomSheet"
import { isMobile } from "react-device-detect"
import ReadMore from "./ReadMore"
import HomeIcon from "../assets/images/home-grey.svg"
import EducationIcon from "../assets/images/graduate-icon.svg"
import ExpertsTooltip from "./ExpertsTooltip"

function WebinarExperts(props) {
  const { id, name, profilePic, qualification, bio, location } = props
  const { domainDetails } = useSelector((state) => state.listings)
  const [visible, setVisible] = useState(false)

  const redirectTo = (ev) => {
    ev.stopPropagation()
    // if (domainDetails && domainDetails.orgType === 'certifier') {
    //   redirectToOmnicuris(`/expert/${id}`, window.self != window.top);
    // } else {
    return false
    // }
  }

  return (
    <div className="webinarsExperts" onClick={redirectTo}>
      <figure onClick={() => setVisible(true)}>
        <Img src={profilePic} defaultSrc={DefaultProfileIcon} alt={name} />
      </figure>
      <ExpertsTooltip name={name} qualification={qualification} location={location} bio={bio} />
      {isMobile && <ExpertsBottomSheet visible={visible} setVisible={setVisible} name={name} profilePic={profilePic} qualification={qualification} location={location} bio={bio} />}
    </div>
  )
}

export default WebinarExperts
